export default __webpack_public_path__ + "static/media/icon-page-not-found.268e99ed.svg";